import React from 'react';

export const NotProvided = () => <span className="not-provided">Not provided</span>;
